var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useWallet } from '@tronweb3/tronwallet-adapter-react-hooks';
import React, { useCallback, useMemo } from 'react';
import { Button } from './Button.js';
export const WalletConnectButton = (_a) => {
    var { children, disabled, onClick } = _a, props = __rest(_a, ["children", "disabled", "onClick"]);
    const { wallet, connect, connecting, connected } = useWallet();
    const handleClick = useCallback((event) => __awaiter(void 0, void 0, void 0, function* () {
        if (onClick)
            onClick(event);
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!event.defaultPrevented) {
            yield connect();
        }
    }), [onClick, connect]);
    const content = useMemo(() => {
        if (children)
            return children;
        if (connecting)
            return 'Connecting ...';
        if (connected)
            return 'Connected';
        if (wallet)
            return 'Connect';
        return 'Connect Wallet';
    }, [children, connecting, connected, wallet]);
    return (React.createElement(Button, Object.assign({ "data-testid": "wallet-connect-button", className: "wallet-button", disabled: disabled || !wallet || connecting || connected, onClick: handleClick, icon: wallet ? wallet.adapter.icon : '' }, props), content));
};
//# sourceMappingURL=WalletConnectButton.js.map